import * as React from "react";
import useCountDown from "react-countdown-hook";

interface IAutoSave {
    saveButtonId: string;
}

export const AutoSave: React.FunctionComponent<IAutoSave> = ({ saveButtonId }) => {
 
    const fifteenMinutes = 60 * 1000 * 15;
    const interval = 1000;
    const [timeLeft, { start, reset }] = useCountDown(fifteenMinutes, interval);

    React.useEffect(() => {
        start();
    }, []);

    React.useEffect(() => {
        if (timeLeft === 1000) {
            document.getElementById(saveButtonId)?.click();
            reset();
            start();
        }
    }, [timeLeft]);

    return (<></>)
}